export const translations = {
  fr: {
    nav: {
      home: "Accueil",
      services: "Services",
      calculators: "Calculateurs",
      contact: "Contact",
      cta: "Prendre Rendez-vous",
    },
    common: {
      since: "ÉTABLI",
      regions: "RÉGIONS",
      hours: "HORAIRES",
      readMore: "En savoir plus",
      submit: "Envoyer la demande",
      sending: "Envoi en cours...",
      required: "Obligatoire",
    },
    home: {
      eyebrow: "CONTRÔLE TECHNIQUE · IMMATRICULATION · IMPORT-EXPORT",
      title1: "Le contrôle",
      title2: "des trois",
      title3: "frontières.",
      sub: "Passage au contrôle technique, prestations à l'immatriculation et procédures import/export pour particuliers et professionnels, entre le Luxembourg, la France et la Belgique.",
      ctaPrimary: "Demander un passage",
      ctaSecondary: "Découvrir les services",
      stats: [
        { k: "3", v: "Pays couverts" },
        { k: "100%", v: "Démarches gérées" },
        { k: "24h", v: "Délai moyen" },
      ],
      sectionLabel1: "01 — NOS PRESTATIONS",
      sectionTitle1: "Une opération.\nTrois territoires.",
      sectionDesc1:
        "De la préparation au contrôle jusqu'à l'immatriculation, en passant par le rapatriement et la commande de votre certificat de conformité (CoC), CT3F prend en charge l'intégralité de vos démarches techniques et administratives.",
      sectionLabel2: "02 — TERRITOIRE D'INTERVENTION",
      sectionTitle2: "Trois pays.\nUne procédure.",
      sectionDesc2:
        "Implantés au cœur de la zone des trois frontières, nous traitons aussi bien les véhicules immatriculés au Luxembourg que ceux en provenance ou à destination de la France et de la Belgique.",
      regions: {
        lu: { name: "Luxembourg", desc: "Centre d'opérations principal. Contrôle technique SNCT, immatriculation SNCA, export." },
        fr: { name: "France", desc: "Importation, quitus fiscal, certificat de conformité, immatriculation préfectorale." },
        be: { name: "Belgique", desc: "Contrôle technique GOCA, DIV, démarches d'immatriculation et d'exportation." },
      },
      sectionLabel3: "03 — POURQUOI CT3F",
      sectionTitle3: "La précision\nau service du véhicule.",
      reasons: [
        { t: "Personne agréée", d: "Contrôle technique réalisé par une personne agréée, en conformité avec la réglementation." },
        { t: "Particuliers & pros", d: "Véhicules particuliers, motos, flottes d'entreprise et professionnels du commerce auto." },
        { t: "Certificat de conformité", d: "Commande de votre CoC auprès de la quasi-totalité des constructeurs — voitures et motos." },
        { t: "Tri-frontalier", d: "Maîtrise des procédures LU, FR et BE — rapatriement, import et export." },
      ],
      ctaTitle: "Préparer votre passage",
      ctaDesc: "Indiquez-nous votre véhicule et le pays concerné. Nous revenons vers vous avec la procédure et le devis.",
      ctaButton: "Ouvrir le formulaire",
    },
    services: {
      eyebrow: "PRESTATIONS CT3F",
      title: "Services",
      sub: "Cinq lignes d'intervention couvrant l'ensemble du cycle technique et administratif de votre véhicule — particuliers et professionnels.",
      list: [
        {
          k: "S/01",
          t: "Passage au contrôle technique",
          d: "Présentation, accompagnement et suivi du véhicule au contrôle technique, périodique ou avant immatriculation. Contrôle réalisé par une personne agréée.",
          items: ["Particuliers", "Professionnels", "Motos", "Flotte de véhicules"],
        },
        {
          k: "S/02",
          t: "Prestation à l'immatriculation",
          d: "Gestion administrative complète du dossier d'immatriculation auprès des autorités compétentes (SNCA, ANTS, DIV). Plaques et documents fournis.",
          items: ["Immatriculation neuve & occasion", "Changement de propriétaire", "Duplicata carte grise", "Gestion administrative"],
        },
        {
          k: "S/03",
          t: "Rapatriement & Import / Export",
          d: "Rapatriement de véhicules entre LU, FR et BE. Procédures d'import et d'export : quitus fiscal, certificat de conformité, dédouanement, radiation.",
          items: ["Rapatriement de véhicules", "Import UE", "Export UE & hors UE", "Quitus fiscal · CoC"],
        },
        {
          k: "S/04",
          t: "Préparation administrative & suivi",
          d: "Vérification et préparation des documents de votre véhicule avant le passage au contrôle ou l'immatriculation, avec un suivi personnalisé de votre dossier de A à Z.",
          items: ["Vérification des documents", "Constitution du dossier", "Suivi personnalisé", "Conseil sur la procédure"],
        },
        {
          k: "S/05",
          t: "Commande de CoC",
          d: "Commande de votre Certificat de Conformité européen (CoC) directement auprès du constructeur — indispensable pour l'immatriculation d'un véhicule importé. Nous couvrons la quasi-totalité des constructeurs. Contactez-nous pour un devis rapide.",
          items: ["Quasi tous les constructeurs", "Voitures & motos", "Document officiel constructeur", "Devis sous 24h ouvrées"],
          cta: "Demander un devis CoC",
        },
      ],
    },
    contact: {
      eyebrow: "PRENEZ CONTACT",
      title1: "Préparons",
      title2: "votre dossier.",
      sub: "Décrivez votre besoin : pays d'origine du véhicule, type de prestation et délais. Nous vous répondons sous 24 heures ouvrées.",
      form: {
        name: "Nom complet",
        namePh: "Jean Dupont",
        email: "Adresse e-mail",
        emailPh: "vous@exemple.com",
        phone: "Téléphone",
        phonePh: "+352 ...",
        subject: "Objet",
        subjectPh: "Contrôle technique import France",
        service: "Service concerné",
        servicePh: "Sélectionnez un service",
        message: "Message",
        messagePh: "Décrivez votre véhicule (marque, modèle, année, immatriculation actuelle) et votre besoin.",
        success: "Demande enregistrée — nous revenons vers vous.",
        error: "Une erreur est survenue. Réessayez.",
        cocBlock: "VÉHICULE CONCERNÉ · DEVIS CoC",
        brand: "Marque",
        brandPh: "Volkswagen",
        model: "Modèle",
        modelPh: "Golf VIII 2.0 TDI",
        vin: "N° de châssis (VIN)",
        vinPh: "WVWZZZ... (recommandé)",
        consentPre: "J'ai lu et j'accepte les",
        consentLink: "conditions générales",
      },
      info: {
        title: "Coordonnées",
        emailLabel: "E-MAIL",
        phoneLabelLu: "TÉLÉPHONE · LU",
        phoneLabelBe: "TÉLÉPHONE · BE",
        contactLabel: "RESPONSABLE",
        contactValue: "RAINALDI Fabrizio",
        facebookLabel: "FACEBOOK",
        hoursLabel: "HORAIRES",
        hoursValue: "Lundi — Vendredi · 08:30 – 17:00",
        regionsLabel: "ZONE D'INTERVENTION",
        regionsValue: "Luxembourg · France · Belgique",
      },
    },
    footer: {
      tag: "Contrôle Technique des trois Frontières",
      desc: "CT3F — passage au contrôle technique, immatriculation, rapatriement et import-export entre le Luxembourg, la France et la Belgique. Contrôle réalisé par une personne agréée.",
      navTitle: "Navigation",
      legalTitle: "Mentions",
      socialTitle: "Suivez-nous",
      legal: ["Mentions légales", "Politique de confidentialité", "Conditions générales"],
      copy: "Tous droits réservés.",
    },
    calculators: {
      eyebrow: "OUTILS · CALCULATEURS OFFICIELS",
      title: "Calculateurs",
      sub: "Estimez gratuitement les frais d'immatriculation et taxes de mise en circulation grâce aux simulateurs officiels des autorités françaises et belges.",
      openLink: "Ouvrir le calculateur",
      disclaimerLabel: "INFORMATION",
      disclaimer:
        "Ces calculateurs sont mis à disposition par les administrations officielles (ANTS, SPW Finances, Bruxelles Fiscalité, Vlaamse Belastingdienst). CT3F renvoie vers ces outils à titre informatif et n'est pas responsable de leur exactitude. Pour une estimation personnalisée intégrant nos honoraires de prestation, contactez-nous directement.",
      ctaEyebrow: "BESOIN D'UNE ESTIMATION COMPLÈTE ?",
      ctaTitle: "Demandez un devis CT3F",
    },
  },

  de: {
    nav: {
      home: "Startseite",
      services: "Leistungen",
      calculators: "Rechner",
      contact: "Kontakt",
      cta: "Termin vereinbaren",
    },
    common: {
      since: "GEGRÜNDET",
      regions: "REGIONEN",
      hours: "ÖFFNUNGSZEITEN",
      readMore: "Mehr erfahren",
      submit: "Anfrage senden",
      sending: "Wird gesendet...",
      required: "Pflichtfeld",
    },
    home: {
      eyebrow: "TECHNISCHE PRÜFUNG · ZULASSUNG · IMPORT-EXPORT",
      title1: "Die Prüfung",
      title2: "der drei",
      title3: "Grenzen.",
      sub: "Technische Fahrzeugprüfung, Zulassungsleistungen sowie Import- und Exportverfahren für Privatkunden und Profis, im Dreiländereck Luxemburg – Frankreich – Belgien.",
      ctaPrimary: "Termin anfragen",
      ctaSecondary: "Leistungen ansehen",
      stats: [
        { k: "3", v: "Länder" },
        { k: "100%", v: "Verfahren übernommen" },
        { k: "24 Std.", v: "Antwortzeit" },
      ],
      sectionLabel1: "01 — UNSERE LEISTUNGEN",
      sectionTitle1: "Ein Vorgang.\nDrei Gebiete.",
      sectionDesc1:
        "Von der Vorbereitung der Prüfung bis zur Zulassung, einschließlich Überführung und CoC-Bestellung — CT3F übernimmt sämtliche technische und administrative Schritte.",
      sectionLabel2: "02 — EINSATZGEBIET",
      sectionTitle2: "Drei Länder.\nEin Verfahren.",
      sectionDesc2:
        "Im Herzen des Dreiländerecks bearbeiten wir Fahrzeuge aus Luxemburg, Frankreich und Belgien — Import wie Export.",
      regions: {
        lu: { name: "Luxemburg", desc: "Hauptstandort. Technische Prüfung SNCT, Zulassung SNCA, Export." },
        fr: { name: "Frankreich", desc: "Import, Steuerquittung, Konformitätsbescheinigung, präfekturelle Zulassung." },
        be: { name: "Belgien", desc: "Technische Prüfung GOCA, DIV, Zulassung und Ausfuhr." },
      },
      sectionLabel3: "03 — WARUM CT3F",
      sectionTitle3: "Präzision\nfür Ihr Fahrzeug.",
      reasons: [
        { t: "Anerkannte Fachkraft", d: "Technische Prüfung durch eine anerkannte Fachkraft, vorschriftsgemäß." },
        { t: "Privat & gewerblich", d: "Pkw, Motorräder, Firmenflotten und Fahrzeughändler." },
        { t: "Konformitätsbescheinigung", d: "Bestellung Ihres CoC bei nahezu allen Herstellern — Pkw und Motorräder." },
        { t: "Dreiländer", d: "Verfahren in LU, FR und BE — Überführung, Import und Export." },
      ],
      ctaTitle: "Ihre Prüfung vorbereiten",
      ctaDesc: "Teilen Sie uns Fahrzeug und Land mit. Wir melden uns mit Verfahren und Angebot.",
      ctaButton: "Formular öffnen",
    },
    services: {
      eyebrow: "CT3F-LEISTUNGEN",
      title: "Leistungen",
      sub: "Fünf Einsatzbereiche, die den gesamten technischen und administrativen Lebenszyklus Ihres Fahrzeugs abdecken — privat und gewerblich.",
      list: [
        {
          k: "S/01",
          t: "Technische Prüfung",
          d: "Vorstellung, Begleitung und Nachverfolgung des Fahrzeugs zur Prüfung — periodisch oder vor Zulassung. Durchführung durch eine anerkannte Fachkraft.",
          items: ["Privatkunden", "Gewerbe", "Motorräder", "Flotten"],
        },
        {
          k: "S/02",
          t: "Zulassungsleistung",
          d: "Vollständige administrative Bearbeitung des Zulassungsdossiers bei den zuständigen Behörden (SNCA, ANTS, DIV).",
          items: ["Erst- & Gebrauchtzulassung", "Halterwechsel", "Duplikat Fahrzeugschein", "Verwaltung gesamt"],
        },
        {
          k: "S/03",
          t: "Überführung & Import/Export",
          d: "Fahrzeugüberführung zwischen LU, FR und BE. Import- und Exportverfahren: Steuerquittung, EU-Konformität, Verzollung, Abmeldung.",
          items: ["Überführung", "EU-Import", "Export EU & Drittland", "Steuerquittung · CoC"],
        },
        {
          k: "S/04",
          t: "Administrative Vorbereitung & Betreuung",
          d: "Prüfung und Vorbereitung der Fahrzeugunterlagen vor der technischen Prüfung oder Zulassung, mit persönlicher Betreuung Ihres Dossiers von A bis Z.",
          items: ["Dokumentenprüfung", "Zusammenstellung des Dossiers", "Persönliche Betreuung", "Verfahrensberatung"],
        },
        {
          k: "S/05",
          t: "CoC-Bestellung",
          d: "Bestellung Ihrer EU-Übereinstimmungsbescheinigung (CoC) direkt beim Hersteller — unerlässlich für die Zulassung eines importierten Fahrzeugs. Wir decken nahezu alle Hersteller ab. Kontaktieren Sie uns für ein schnelles Angebot.",
          items: ["Nahezu alle Hersteller", "Pkw & Motorräder", "Offizielles Herstellerdokument", "Angebot innerhalb von 24 Std."],
          cta: "CoC-Angebot anfordern",
        },
      ],
    },
    contact: {
      eyebrow: "KONTAKT",
      title1: "Bereiten wir",
      title2: "Ihr Dossier vor.",
      sub: "Beschreiben Sie Ihren Bedarf: Herkunftsland, Art der Leistung und Frist. Antwort innerhalb von 24 Stunden.",
      form: {
        name: "Vollständiger Name",
        namePh: "Max Mustermann",
        email: "E-Mail-Adresse",
        emailPh: "sie@beispiel.com",
        phone: "Telefon",
        phonePh: "+352 ...",
        subject: "Betreff",
        subjectPh: "Technische Prüfung Import Frankreich",
        service: "Gewünschte Leistung",
        servicePh: "Leistung wählen",
        message: "Nachricht",
        messagePh: "Beschreiben Sie Ihr Fahrzeug (Marke, Modell, Baujahr, aktuelle Zulassung) und Ihren Bedarf.",
        success: "Anfrage gespeichert — wir melden uns.",
        error: "Ein Fehler ist aufgetreten. Bitte erneut versuchen.",
        cocBlock: "BETREFFENDES FAHRZEUG · CoC-ANGEBOT",
        brand: "Marke",
        brandPh: "Volkswagen",
        model: "Modell",
        modelPh: "Golf VIII 2.0 TDI",
        vin: "Fahrgestellnummer (VIN)",
        vinPh: "WVWZZZ... (empfohlen)",
        consentPre: "Ich habe die",
        consentLink: "AGB gelesen und akzeptiere sie",
      },
      info: {
        title: "Kontaktdaten",
        emailLabel: "E-MAIL",
        phoneLabelLu: "TELEFON · LU",
        phoneLabelBe: "TELEFON · BE",
        contactLabel: "ANSPRECHPARTNER",
        contactValue: "RAINALDI Fabrizio",
        facebookLabel: "FACEBOOK",
        hoursLabel: "ÖFFNUNGSZEITEN",
        hoursValue: "Montag — Freitag · 08:30 – 17:00",
        regionsLabel: "EINSATZGEBIET",
        regionsValue: "Luxemburg · Frankreich · Belgien",
      },
    },
    footer: {
      tag: "Contrôle Technique des trois Frontières",
      desc: "CT3F — technische Prüfung, Zulassung, Überführung sowie Import-Export zwischen Luxemburg, Frankreich und Belgien. Durchführung durch eine anerkannte Fachkraft.",
      navTitle: "Navigation",
      legalTitle: "Rechtliches",
      socialTitle: "Folgen Sie uns",
      legal: ["Impressum", "Datenschutz", "AGB"],
      copy: "Alle Rechte vorbehalten.",
    },
    calculators: {
      eyebrow: "TOOLS · OFFIZIELLE RECHNER",
      title: "Rechner",
      sub: "Schätzen Sie kostenlos die Zulassungs- und Erstzulassungssteuer mit den offiziellen Simulatoren der französischen und belgischen Behörden.",
      openLink: "Rechner öffnen",
      disclaimerLabel: "HINWEIS",
      disclaimer:
        "Diese Rechner werden von den offiziellen Verwaltungen bereitgestellt (ANTS, SPW Finances, Bruxelles Fiscalité, Vlaamse Belastingdienst). CT3F verweist auf diese Tools zu Informationszwecken und haftet nicht für deren Richtigkeit. Für eine personalisierte Schätzung inklusive unserer Servicegebühren kontaktieren Sie uns direkt.",
      ctaEyebrow: "BENÖTIGEN SIE EINEN VOLLSTÄNDIGEN KOSTENVORANSCHLAG?",
      ctaTitle: "Fordern Sie ein CT3F-Angebot an",
    },
  },

  en: {
    nav: {
      home: "Home",
      services: "Services",
      calculators: "Calculators",
      contact: "Contact",
      cta: "Book Inspection",
    },
    common: {
      since: "ESTABLISHED",
      regions: "REGIONS",
      hours: "HOURS",
      readMore: "Read more",
      submit: "Send request",
      sending: "Sending...",
      required: "Required",
    },
    home: {
      eyebrow: "TECHNICAL INSPECTION · REGISTRATION · IMPORT-EXPORT",
      title1: "Inspection",
      title2: "across three",
      title3: "borders.",
      sub: "Vehicle technical inspection, registration services and import/export procedures for individuals and professionals across Luxembourg, France and Belgium.",
      ctaPrimary: "Request inspection",
      ctaSecondary: "View services",
      stats: [
        { k: "3", v: "Countries covered" },
        { k: "100%", v: "Procedures handled" },
        { k: "24h", v: "Average reply" },
      ],
      sectionLabel1: "01 — OUR SERVICES",
      sectionTitle1: "One operation.\nThree territories.",
      sectionDesc1:
        "From inspection preparation to registration, transfer and CoC ordering — CT3F handles the entire technical and administrative cycle of your vehicle.",
      sectionLabel2: "02 — OPERATIONAL ZONE",
      sectionTitle2: "Three countries.\nOne procedure.",
      sectionDesc2:
        "Operating from the heart of the tri-border region, we process vehicles registered in Luxembourg as well as those entering or leaving France and Belgium.",
      regions: {
        lu: { name: "Luxembourg", desc: "Main operations centre. SNCT inspection, SNCA registration, export." },
        fr: { name: "France", desc: "Import, fiscal clearance, certificate of conformity, prefectural registration." },
        be: { name: "Belgium", desc: "GOCA technical inspection, DIV, registration and export procedures." },
      },
      sectionLabel3: "03 — WHY CT3F",
      sectionTitle3: "Precision\nat the service of your vehicle.",
      reasons: [
        { t: "Approved professional", d: "Technical inspection carried out by an approved professional, fully compliant." },
        { t: "Private & business", d: "Cars, motorcycles, company fleets and automotive dealers." },
        { t: "Certificate of Conformity", d: "CoC ordering from nearly all manufacturers — cars and motorcycles." },
        { t: "Tri-border", d: "Mastery of LU, FR and BE procedures — vehicle transfer, import and export." },
      ],
      ctaTitle: "Prepare your inspection",
      ctaDesc: "Tell us about your vehicle and the country involved. We'll reply with procedure and quote.",
      ctaButton: "Open the form",
    },
    services: {
      eyebrow: "CT3F SERVICES",
      title: "Services",
      sub: "Five lines of intervention covering the entire technical and administrative cycle of your vehicle — individuals and professionals.",
      list: [
        {
          k: "S/01",
          t: "Technical inspection",
          d: "Vehicle presentation, accompaniment and follow-up at periodic or pre-registration inspection. Carried out by an approved professional.",
          items: ["Individuals", "Professionals", "Motorcycles", "Vehicle fleets"],
        },
        {
          k: "S/02",
          t: "Registration service",
          d: "Full administrative handling of the registration dossier with relevant authorities (SNCA, ANTS, DIV). Plates and documents provided.",
          items: ["New & used registration", "Owner change", "Registration duplicate", "Full admin handling"],
        },
        {
          k: "S/03",
          t: "Transfer & Import/Export",
          d: "Vehicle transfer between LU, FR and BE. Import and export procedures: fiscal clearance, EU conformity, customs, de-registration.",
          items: ["Vehicle transfer", "Intra-EU import", "Export EU & non-EU", "Fiscal clearance · CoC"],
        },
        {
          k: "S/04",
          t: "Administrative preparation & follow-up",
          d: "Verification and preparation of your vehicle's documents ahead of inspection or registration, with personal follow-up of your file from A to Z.",
          items: ["Document verification", "File preparation", "Personal follow-up", "Procedure guidance"],
        },
        {
          k: "S/05",
          t: "CoC ordering",
          d: "Ordering of your European Certificate of Conformity (CoC) directly from the manufacturer — essential for registering an imported vehicle. We cover nearly all manufacturers. Contact us for a quick quote.",
          items: ["Nearly all manufacturers", "Cars & motorcycles", "Official manufacturer document", "Quote within 24 working hours"],
          cta: "Request a CoC quote",
        },
      ],
    },
    contact: {
      eyebrow: "GET IN TOUCH",
      title1: "Let's prepare",
      title2: "your file.",
      sub: "Describe your need: vehicle origin country, type of service and timing. Reply within 24 working hours.",
      form: {
        name: "Full name",
        namePh: "John Doe",
        email: "Email address",
        emailPh: "you@example.com",
        phone: "Phone",
        phonePh: "+352 ...",
        subject: "Subject",
        subjectPh: "Technical inspection import France",
        service: "Related service",
        servicePh: "Select a service",
        message: "Message",
        messagePh: "Describe your vehicle (make, model, year, current registration) and your need.",
        success: "Request saved — we'll get back to you.",
        error: "An error occurred. Please retry.",
        cocBlock: "VEHICLE · CoC QUOTE",
        brand: "Make",
        brandPh: "Volkswagen",
        model: "Model",
        modelPh: "Golf VIII 2.0 TDI",
        vin: "Chassis number (VIN)",
        vinPh: "WVWZZZ... (recommended)",
        consentPre: "I have read and accept the",
        consentLink: "terms of service",
      },
      info: {
        title: "Details",
        emailLabel: "EMAIL",
        phoneLabelLu: "PHONE · LU",
        phoneLabelBe: "PHONE · BE",
        contactLabel: "POINT OF CONTACT",
        contactValue: "RAINALDI Fabrizio",
        facebookLabel: "FACEBOOK",
        hoursLabel: "HOURS",
        hoursValue: "Monday — Friday · 08:30 – 17:00",
        regionsLabel: "OPERATIONAL ZONE",
        regionsValue: "Luxembourg · France · Belgium",
      },
    },
    footer: {
      tag: "Contrôle Technique des trois Frontières",
      desc: "CT3F — technical inspection, registration, vehicle transfer and import-export between Luxembourg, France and Belgium. Performed by an approved professional.",
      navTitle: "Navigation",
      legalTitle: "Legal",
      legal: ["Legal notice", "Privacy policy", "Terms of use"],
      copy: "All rights reserved.",
    },
  },
};
